import {
  INSPECT_WEBHOOK_COMPLETED,
  INSPECT_WEBHOOK_URL_STATUS_CHANGED,
  WEBHOOK_BUCKET_IDS,
} from './inspect-webhook-events';

export type InspectScheduleSettingsMode = 'default' | 'advanced';

export const RECOMMENDED_SETTINGS_LABEL = 'تنظیمات پیشنهادی';

export const RECOMMENDED_SETTINGS_ALERT =
  'این تنظیمات پیشنهادی میزفا تولز است و معمولاً بهترین نتیجه را می‌دهد: روزانه وضعیت ایندکس بررسی می‌شود، برای آدرس‌های نوایندکس درخواست ایندکس ارسال می‌شود، و نتیجه از طریق تلگرام، بله و اعلان داخل سایت به شما اطلاع داده می‌شود.';

/**
 * پیشنهادی: همه تیک‌ها به‌جز «وضعیت فعلی هر آدرس».
 * — پایان کل وضعیت ایندکس
 * — فقط وقتی وضعیت عوض شد
 * — ارسال درخواست ایندکس برای نوایندکس
 */
export const DEFAULT_INSPECT_SCHEDULE_EVENTS = [
  INSPECT_WEBHOOK_COMPLETED,
  INSPECT_WEBHOOK_URL_STATUS_CHANGED,
] as const;

export const DEFAULT_INSPECT_SCHEDULE_AUTO_INDEX = true;

export const DEFAULT_INSPECT_SCHEDULE_FILTERS = [...WEBHOOK_BUCKET_IDS];

export function defaultInspectScheduleEvents(): string[] {
  return [...DEFAULT_INSPECT_SCHEDULE_EVENTS];
}

export function defaultInspectScheduleFilters(): string[] {
  return [...DEFAULT_INSPECT_SCHEDULE_FILTERS];
}

export function applyDefaultInspectScheduleSettings(): {
  events: string[];
  filters: string[];
  autoIndexNotIndexed: boolean;
} {
  return {
    events: defaultInspectScheduleEvents(),
    filters: defaultInspectScheduleFilters(),
    autoIndexNotIndexed: DEFAULT_INSPECT_SCHEDULE_AUTO_INDEX,
  };
}

export function normalizeInspectScheduleSettingsMode(
  value: unknown,
): InspectScheduleSettingsMode {
  return value === 'advanced' ? 'advanced' : 'default';
}

export function inferInspectScheduleSettingsMode(input: {
  settingsMode?: unknown;
  webhookEvents?: string[];
  autoIndexNotIndexed?: boolean;
}): InspectScheduleSettingsMode {
  if (input.settingsMode === 'advanced' || input.settingsMode === 'default') {
    return input.settingsMode;
  }
  const preset = applyDefaultInspectScheduleSettings();
  const events = [...(input.webhookEvents ?? [])].sort();
  const expected = [...preset.events].sort();
  const eventsMatch =
    events.length === expected.length &&
    events.every((id, index) => id === expected[index]);
  const autoMatch =
    Boolean(input.autoIndexNotIndexed) === preset.autoIndexNotIndexed;
  return eventsMatch && autoMatch ? 'default' : 'advanced';
}
